import { render, staticRenderFns } from "./PropertyFiles.vue?vue&type=template&id=35697384&"
import script from "./PropertyFiles.vue?vue&type=script&lang=js&"
export * from "./PropertyFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports